export const plans = [
  {
    id: 'basic',
    name: 'McAfee Basic',
    tagline: 'Essential cover for a single device',
    price: '29.99',
    strike: '59.99',
    term: 'first year',
    devices: '1 Device',
    features: [
      'Award-winning antivirus engine',
      'Real-time malware & ransomware defence',
      'Safe web browsing extension',
      'Automatic virus definition updates',
      'Email & chat support',
    ],
    cta: 'Choose Basic',
  },
  {
    id: 'total',
    name: 'McAfee Total Protection',
    tagline: 'Our best value for families',
    price: '49.99',
    strike: '119.99',
    term: 'first year',
    devices: 'Up to 5 Devices',
    featured: true,
    badge: 'Most Popular',
    features: [
      'Everything in Basic, plus:',
      'Secure VPN with unlimited data',
      'Password manager for the whole family',
      'Identity monitoring & breach alerts',
      'Parental controls & screen-time limits',
      'File shredder and PC optimisation',
      'Priority 24/7 phone support',
    ],
    cta: 'Get Total Protection',
  },
  {
    id: 'ultimate',
    name: 'McAfee Ultimate',
    tagline: 'Maximum security for every device',
    price: '89.99',
    strike: '199.99',
    term: 'first year',
    devices: 'Unlimited Devices',
    features: [
      'Everything in Total Protection, plus:',
      'Advanced identity restoration support',
      'Credit monitoring & score tracking',
      'Personal data cleanup service',
      'Dark web surveillance',
      'Dedicated security advisor',
    ],
    cta: 'Choose Ultimate',
  },
];

export const products = [
  {
    name: 'McAfee Total Protection',
    subtitle: '5 Devices · 1 Year',
    price: '49.99',
    strike: '119.99',
    tone: 'crimson',
    tag: 'Best Seller',
  },
  {
    name: 'McAfee Antivirus Plus',
    subtitle: '10 Devices · 1 Year',
    price: '39.99',
    strike: '99.99',
    tone: 'ember',
    tag: 'Value Pick',
  },
  {
    name: 'McAfee Internet Security',
    subtitle: '3 Devices · 1 Year',
    price: '44.99',
    strike: '109.99',
    tone: 'slate',
  },
  {
    name: 'McAfee Safe Family',
    subtitle: '10 Devices · 1 Year',
    price: '34.99',
    strike: '79.99',
    tone: 'rose',
    tag: 'Parents Love It',
  },
  {
    name: 'McAfee Mobile Security',
    subtitle: '1 Device · 1 Year',
    price: '19.99',
    strike: '49.99',
    tone: 'crimson',
  },
  {
    name: 'McAfee Ultimate Suite',
    subtitle: 'Unlimited · 1 Year',
    price: '89.99',
    strike: '199.99',
    tone: 'ember',
    tag: 'Complete',
  },
];

export const trustPoints = [
  {
    title: 'Genuine Licence Keys',
    text: 'Every activation code is sourced through authorised channels.',
    icon: 'shield',
  },
  {
    title: 'Instant Digital Delivery',
    text: 'Your download link and key arrive within minutes of checkout.',
    icon: 'bolt',
  },
  {
    title: 'Secure Payments',
    text: '256-bit encrypted checkout with all major cards accepted.',
    icon: 'lock',
  },
  {
    title: 'Expert Setup Help',
    text: 'Talk to a specialist who installs and configures it with you.',
    icon: 'headset',
  },
];

export const features = [
  {
    title: 'Advanced Threat Detection',
    text: 'Machine-learning scanning stops viruses, trojans, spyware, and zero-day ransomware before they execute on your machine.',
    icon: 'radar',
  },
  {
    title: 'Identity Protection',
    text: 'We watch the dark web for your email, cards, and IDs, then alert you the moment your details surface in a breach.',
    icon: 'fingerprint',
  },
  {
    title: 'Unlimited Secure VPN',
    text: 'Bank-grade encryption on public Wi-Fi with no data caps, so your browsing stays private wherever you connect.',
    icon: 'globe',
  },
  {
    title: 'Smart Firewall',
    text: 'Blocks intrusion attempts and suspicious outbound traffic while staying invisible to hackers scanning your network.',
    icon: 'wall',
  },
  {
    title: 'Performance Optimiser',
    text: 'Clears junk files, trims startup apps, and frees memory so protection never comes at the cost of speed.',
    icon: 'gauge',
  },
  {
    title: 'Family Safeguards',
    text: 'Screen-time schedules, app limits, and content filters that keep younger users safe across every household device.',
    icon: 'family',
  },
];

export const comparisonRows = [
  { label: 'Antivirus & anti-malware engine', values: [true, true, true] },
  { label: 'Real-time ransomware shield', values: [true, true, true] },
  { label: 'Safe browsing & phishing blocker', values: [true, true, true] },
  { label: 'Smart firewall', values: [false, true, true] },
  { label: 'Unlimited secure VPN', values: [false, true, true] },
  { label: 'Password manager', values: [false, true, true] },
  { label: 'Parental controls', values: [false, true, true] },
  { label: 'Identity monitoring', values: [false, true, true] },
  { label: 'Credit & dark web monitoring', values: [false, false, true] },
  { label: 'Identity restoration specialist', values: [false, false, true] },
  { label: 'Devices covered', values: ['1', 'Up to 5', 'Unlimited'] },
];

export const faqs = [
  {
    q: 'How do I install McAfee after I buy?',
    a: 'You receive your activation key and download link by email straight after checkout. Run the installer, paste the key when prompted, and the software finishes setup on its own. If anything looks unfamiliar, call our team and a specialist will complete the install with you on the line.',
  },
  {
    q: 'Will McAfee slow down my computer?',
    a: 'Modern McAfee builds run scans while your system is idle and use cloud lookups instead of heavy local processing. Most users see no measurable slowdown, and the built-in optimiser typically frees up memory and startup time compared to an unprotected machine.',
  },
  {
    q: 'Can I use one subscription on several devices?',
    a: 'Yes. Total Protection covers up to five devices and the Ultimate plan covers unlimited devices in your household. You can mix Windows, macOS, Android, and iOS under a single account and move a licence between devices at any time.',
  },
  {
    q: 'What happens when my subscription expires?',
    a: 'Protection stops updating once the term ends, which leaves you exposed to newly discovered threats. We send renewal reminders ahead of time and you can renew at a discounted rate by calling our support desk before the expiry date.',
  },
  {
    q: 'Do you offer refunds?',
    a: 'Yes. Unused licence keys qualify for a full refund within 30 days of purchase. Refunds are processed to your original payment method, typically within 7 to 10 business days. See our Refund Policy page for the complete terms.',
  },
  {
    q: 'Is this the official McAfee website?',
    a: 'No. MaxKeys is an independent reseller and technical support provider. We supply genuine licences and hands-on setup assistance, but we are not affiliated with, endorsed by, or sponsored by McAfee, LLC.',
  },
];

export const testimonials = [
  {
    quote:
      'I had ransomware lock up my work laptop on a Friday night. The team stayed on the phone, cleaned the machine, and had Total Protection running before midnight. Genuinely impressive.',
    name: 'Daniel Reyes',
    role: 'Freelance Architect · Austin, TX',
    rating: 5,
  },
  {
    quote:
      'Setting up parental controls across four devices sounded like a nightmare. It took one call and about twenty minutes. My kids are covered and I finally understand what the settings actually do.',
    name: 'Priya Raman',
    role: 'Teacher · Columbus, OH',
    rating: 5,
  },
  {
    quote:
      'Ordered on a Sunday, had the key in my inbox in under five minutes, and the VPN was live on my phone and laptop the same afternoon. No hunting for downloads, no surprises at checkout.',
    name: 'Marcus Bell',
    role: 'Small Business Owner · Denver, CO',
    rating: 5,
  },
];

export const stats = [
  { value: '600M+', label: 'Threats blocked each month' },
  { value: '4.8/5', label: 'Average customer rating' },
  { value: '24/7', label: 'Live specialist support' },
  { value: '30-Day', label: 'Money-back guarantee' },
];

export const articles = [
  {
    kicker: 'Threat Report',
    title: 'Phishing emails are getting harder to spot. Here is what to check.',
    text: 'Attackers now copy real invoice templates and sender names. Four quick checks stop almost all of them before you click.',
    read: '5 min read',
  },
  {
    kicker: 'How-To Guide',
    title: 'Setting up a secure VPN on every device in your home',
    text: 'A step-by-step walkthrough for phones, laptops, tablets, and smart TVs, including what to do on public Wi-Fi.',
    read: '7 min read',
  },
  {
    kicker: 'Family Safety',
    title: 'A practical guide to parental controls that kids will accept',
    text: 'Filters work best when they are explained. How to set boundaries that protect without starting an argument.',
    read: '6 min read',
  },
];
